import { createApp } from 'vue'
import App from '@/page/vue/2023/membership.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: '共建ISC 2023！早鸟招商全面启动',
  desc: 'ISC 2023第十一届互联网安全大会招商正式启动！',
  imgUrl: 'https://p2.ssl.qhimg.com/t0192d7ce9eb6abf8f2.png',
  link: window.location.href
})

const app = createApp(App)
app.mount('#app')
